var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconWatchLaterOutline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1.4 -0.3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1339.9,171.8a20,20,0,1,1,20,20A20,20,0,0,1,1339.9,171.8Zm3.626,0a16.374,16.374,0,1,0,16.374-16.374A16.415,16.415,0,0,0,1343.526,171.8Zm17.411,1.428h-2.906v-12.2a1.853,1.853,0,0,1,1.868-1.868,1.789,1.789,0,0,1,1.868,1.868v8.462h9.011a1.852,1.852,0,0,1,1.868,1.867,1.789,1.789,0,0,1-1.868,1.868Z",
    transform: "translate(-1338 -151)",
    stroke: "rgba(0,0,0,0)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWatchLaterOutline);
export default __webpack_public_path__ + "static/media/icon-watch-later-outline.5166394b.svg";
export { ForwardRef as ReactComponent };